import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  controlAreaClass: {
    display: "flex",
    minWidth: 180,
  },
  addButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    width: "100%",
  },
  filters: {
    margin: "0.8rem 0",
    display: "flex",
  },
  branchFilter: {
    width: "80%",
    paddingRight: "0.5rem",
  },
  dateFilter: {
    width: "20%",
  },
  checkBox:{
    display: "flex",
    alignItems: "center",
    marginLeft:-15,
    padding:5,
    marginTop:-30
   },
   message:{
      fontSize: '1.3em',
      textAlign: 'center',
      width: '100%',
      display: 'block'
   },
   titleBlock: {
      fontSize: '1em',
      textAlign: 'center',
      width: '100%',
      display: 'block'
   }

}));

export default useStyles;
